import type { BookingUrlCodesEntry, EnhancedLocation, InboxReminder } from 'owa-graph-schema';
import type { IWorkDay } from 'owa-scheduling-hours';
import type { OwaDate } from 'owa-datetime';
import type BookingPrivacyType from './BookingPrivacyType';
import type UserInfo from './UserInfo';
import type {
    ErrorValidationParams,
    AvailabilityErrorValidationParams,
} from './EventifyEventComposeViewState';
export interface MeetingTypeEditOptionState {
    id: string;
    name: string;
    description: string;
    inboxReminders?: InboxReminder[];
    charm: number;
    categoryNames: Array<string>;
    duration: number;
    location: EnhancedLocation;
    isOnlineMeeting: boolean;
    schedulingPolicy: SchedulingPolicyState;
    availability: AvailabilityState;
    hasError: boolean;
    showErrorMessage: boolean;
    excludeFromSelfService: boolean;
    preBuffer: number;
    postBuffer: number;
    needsTitle: ErrorValidationParams;
    validateDescription: ErrorValidationParams;
    validateMinAndMax: ErrorValidationParams;
    privacyType: BookingPrivacyType;
    themeImageIdPromise?: Promise<string | null>;
    emojiCode: string;
    themeImage: string;
    attendees: UserInfo[];
    invalidRecipientEmail: ErrorValidationParams;
    createLink: boolean;
    isAttendeeAuthRequired: boolean;
    additionalInformation: string;
    validateAvailability: AvailabilityErrorValidationParams;
    origin: string;
    bookingUrlCodes: BookingUrlCodesEntry[];
}

export interface SchedulingPolicyState {
    leadTimeInMinutes: number;
    endOfBookingWindowInDays: number;
    timeSlotIntervalInMinutes: number;
}

export interface AvailabilityState {
    availabilityType?: AvailabilityType;
    isDateRestricted?: boolean;
    startDate?: OwaDate;
    endDate?: OwaDate;
    customHours?: IWorkDay[];
    isDirty?: boolean;
}

export enum AvailabilityType {
    Undefined = 0,
    DefaultSetup = 1,
    NotBookable = 2,
    Custom = 3,
}

export default MeetingTypeEditOptionState;
